var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatIsAnHraMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 389,
    viewBox: "0 0 463 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2537 306.135L12.7444 305.574C12.9091 305.766 13.0789 305.953 13.2537 306.135Z",
    fill: "#436482"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445.395 9.8185L449.803 4.67548L458.831 14.0264C461.894 17.1565 463.485 21.6886 462.602 26.4182L411.732 298.999C410.492 305.638 404.697 310.452 397.943 310.452H23.3766C19.3559 310.452 15.7862 308.779 13.2537 306.135L12.7444 305.574L3.62622 295.53L9.62344 293.658L59.1754 21.3339C60.3889 14.6654 66.1972 9.8185 72.9753 9.8185H445.395Z",
    fill: "#436482"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.384 288.717L453.246 16.6036C454.859 7.97376 448.237 0 439.458 0H63.6214C56.8448 0 51.0372 4.84486 49.8222 11.5117L0.231537 283.625C-1.33789 292.236 5.27722 300.166 14.0307 300.166H388.596C395.349 300.166 401.143 295.354 402.384 288.717Z",
    fill: "#58799C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7921 14.0264C65.3765 14.0264 63.3062 15.7535 62.8731 18.13L15.1053 280.243C14.5459 283.313 16.904 286.139 20.0243 286.139H384.443C386.85 286.139 388.916 284.424 389.358 282.058L438.351 19.9451C438.926 16.8688 436.566 14.0264 433.436 14.0264H67.7921Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.659 374.978L268.395 310.452H156.183L185.171 376.844L296.448 385.26V378.87C296.448 377.533 296.18 376.209 295.659 374.978Z",
    fill: "#436482"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.967 377.311L260.914 310.452H148.702L177.69 377.311H288.967Z",
    fill: "#58799C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296.448 379.844C296.448 378.187 295.105 376.844 293.448 376.844H130.195C128.538 376.844 127.195 378.187 127.195 379.844V386C127.195 387.657 128.538 389 130.195 389H293.448C295.105 389 296.448 387.657 296.448 386V379.844Z",
    fill: "#436482"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatIsAnHraMonitor);
export default __webpack_public_path__ + "static/media/whatIsAnHRAMonitor.7fb47af2f06b05e6616c53fec1f02d21.svg";
export { ForwardRef as ReactComponent };